import React, { Component, Fragment, useEffect } from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS, PAGINATION, PATHS } from "../../../../constants/Define";
import PromotionList from './PromotionList';
import { Input, Button, Tooltip, Icon, message, Tabs } from 'antd'
import AntSelect, { AntOption } from '../../common/component/AntSelect';

import './Promotion.less'
import PromotionUpdateStatus from './PromotionModal/UpdateStatus';
import PromotionHistory from './PromotionModal/History';
import PromotionSchedules from './PromotionModal/Schedules';
import BundleList from "./BundleList";
import { Link } from "react-router-dom";
import Ripple from "../../common/component/Ripple";
import Modal from "../../common/component/Modal";
import { formatValidation } from "../../../../helpers/functions";
import i18n from "../../../../constants/initLng";
import UpdateStatusGroup from './PromotionModal/UpdateStatusGroup';

const { TextArea } = Input;
let permissionActions = [];
const { TabPane } = Tabs;
let bundlePermissionActions = [];

export default class Promotions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.promotionState.pageSize,
                pageIndex: this.props.promotionState.pageIndex,
            },
            filtersHistory: {
                pageSize: this.props.promotionState.histories.pageSize,
                pageIndex: this.props.promotionState.histories.pageIndex,
            },
            note: '',
            dataSearch: {
                textSearch: '',
                campaignId: undefined,
                bundleId: undefined,
            },
            dataCode: null,
            dataHistory: null,
            dataSchedules: null,
            activeTab: "BUNDLE",
            isShowBtnUpdateStatus: false,
            isActive: undefined,
            selectedRows: [],
            showChangeStatusGroup: false
        }
        this.childPromotion = React.createRef();
    }

    componentDidMount() {
        const { activeTab } = this.state;
        const { location, history } = this.props;
        let keyActiveTab = activeTab;
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PROMOTION_MANAGEMENT);
        keyActiveTab = permissionActions.allowViewBundle ? "BUNDLE" : "PROMOTION";
        this.setState({ activeTab: keyActiveTab });
        this.props.getAllCampaign();
        const locationState = location.state;
        if (locationState && locationState.id && locationState.isFromCampaign) {
            keyActiveTab = "PROMOTION";
            this.onViewPromotionCode({
                keyActive: keyActiveTab,
                campaignId: locationState.id,
            });
            history.replace();
        }
        if (keyActiveTab === 'BUNDLE') {
            this.props.getListBundle(this.state.filters);
        }
    }

    onExecuteBulkUpdatePromotionStatus = () => {
        const { selectedRows, isActive, filters, dataSearch } = this.state;
        const { bulkUpdatePromotionStatus } = this.props;
        if (selectedRows && selectedRows.length > 0) {
            const arrIds = [];
            selectedRows.map(item => {
                const promotionId = item && item.__data__ && item.__data__.promotionId;
                if (item && promotionId && !arrIds.includes(promotionId)) {
                    arrIds.push(promotionId);
                }
            })
            if (arrIds && arrIds.length > 0) {
                bulkUpdatePromotionStatus && bulkUpdatePromotionStatus({
                    guIds: arrIds,
                    isActive: !isActive,
                }, {...filters, ...dataSearch})
            }
        }
    }

    onBulkUpdatePromotionCode = () => {
        const { confirm } = Modal;
        confirm({
            title: formatValidation(i18n.t('validation.statusCode.code.ACTION'), ''),
            okText: i18n.t(`action.save`),
            cancelText: i18n.t(`action.cancel`),
            onOk: () => this.onExecuteBulkUpdatePromotionStatus(),
        });
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, promotions, campaigns, bundles, isFetchingDownload, histories, isFetchingHistory } = this.props.promotionState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
        const { dataCode, note, dataSearch, dataHistory, dataSchedules, activeTab, isShowBtnUpdateStatus, isActive, showChangeStatusGroup } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={ FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage }>
                    <HMS.HeaderListComponent
                        path={ this.props.match.path }
                        groupPath={ 'promotions' }
                        titleHeader={ t('navigation.promotionsManagerment') }
                        componentRight={
                            <Fragment>
                                {/* {
                            permisionActions && permisionActions.allowCreate &&
                            <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                <Link to={PATHS.PROMOTION.CREATE.path}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            </Ripple>
                        } */ }
                                {
                                    permissionActions && permissionActions.allowUpdateActiveByExcel && activeTab === 'PROMOTION' &&
                                    <Button className='btn btn-primary ml-3' disabled={ isFetchingDownload }
                                            onClick={ this.popupChangeStatusGroup }>
                                        <Icon type={ isFetchingDownload ? 'loading' : 'download' } className="mr-1"/>{ t(`action.updateActiveByExcel`) }
                                    </Button>
                                }
                                {
                                    permissionActions && permissionActions.allowExportFileExcel && activeTab === 'PROMOTION' &&
                                    <Button className='btn btn-primary ml-3' disabled={ isFetchingDownload }
                                            onClick={ this.onClickDownloadExcel }>
                                        <Icon type={ isFetchingDownload ? 'loading' : 'download' } className="mr-1"/>{ t(`action.export`) }
                                    </Button>
                                }
                                {
                                    activeTab === 'BUNDLE' && permissionActions.allowCreateBundle &&
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={ true }>
                                        <Link to={ PATHS.PROMOTION.CREATE.path } className='btn btn-primary'>+ { t(`action.create`) }</Link>
                                    </Ripple>
                                }
                            </Fragment>
                        }
                    />
                    <Tabs defaultActiveKey={ activeTab } onChange={ this.onChangeTab } activeKey={ activeTab }>
                        {
                            permissionActions.allowViewBundle &&
                            <TabPane tab={ <span><Icon type="faTag"/>{ t('item.bundle.tabBundleTitle') }</span> } key="BUNDLE">
                                <BundleList
                                    getListBundle={ this.props.getListBundle }
                                    promotionState={ this.props.promotionState }
                                    fetchBundleLst={ this.state.fetchBundleLst }
                                    onViewPromotionCode={ this.onViewPromotionCode }
                                    permissionActions={ permissionActions }
                                    changeBundleStatus={ this.props.changeBundleStatus }
                                />
                            </TabPane>
                        }
                        {
                            permissionActions.allowView &&
                            <TabPane tab={ <span><Icon type="faTag"/>{ t('item.bundle.tabPromotionTitle') }</span> } key="PROMOTION">
                                <div className="box-search-promotion">
                                    <div className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            dataValidation={ dataSearch.textSearch }
                                            labelTitle={ t(`item.promotions.textSearch`) }
                                        >
                                            <Input placeholder="" type={ `text` }
                                                   className={ `form-control input-clear-custom` }
                                                   allowClear
                                                   name={ `name` } onChange={ (e) => this.onChange('textSearch', e.target.value) }
                                                   onKeyDown={ this.onEnterSearch }
                                                   value={ Func.checkUndefine(dataSearch.textSearch) }/>
                                        </HMS.FormWrapperInputComponent>
                                    </div>

                                    <div className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={ t(`item.promotions.campaign`) }
                                        >
                                            <AntSelect className="select-types"
                                                       showArrow
                                                       allowClear
                                                       placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.campaign")).toLowerCase()) }
                                                       value={ dataSearch.campaignId }
                                                       onChange={ campaignId => {
                                                           this.onChange('campaignId', campaignId)
                                                           this.props.getBundlesByCampaignId(campaignId)
                                                       } }
                                                       style={ { width: '100%' } }
                                                       filterOption={ this.props.selectFilterSearch }
                                            >
                                                { (campaigns || []).map(campaign => (
                                                    <AntOption key={ campaign.id } value={ campaign.id }>
                                                        <Tooltip title={ campaign.name } placement="topLeft">{ `${ campaign.code } - ${ campaign.name }` }</Tooltip>
                                                    </AntOption>
                                                )) }
                                            </AntSelect>
                                        </HMS.FormWrapperInputComponent>
                                    </div>

                                    <div className="col-md-3">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={ t(`item.promotions.bundle`) }
                                        >
                                            <AntSelect className="select-types"
                                                       showArrow
                                                       allowClear
                                                       disabled={ !dataSearch.campaignId }
                                                       placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.bundle")).toLowerCase()) }
                                                       value={ dataSearch.bundleId }
                                                       onChange={ bundleId => this.onChange('bundleId', bundleId) }
                                                       style={ { width: '100%' } }
                                                       filterOption={ this.props.selectFilterSearch }
                                            >
                                                { (bundles || []).map(bundle => (
                                                    <AntOption key={ bundle.id } value={ bundle.id }>
                                                        <Tooltip title={ bundle.name } placement="topLeft">{ `${ bundle.code } - ${ bundle.name }` }</Tooltip>
                                                    </AntOption>
                                                )) }
                                            </AntSelect>
                                        </HMS.FormWrapperInputComponent>
                                    </div>

                                    <div className="col-md-12 text-right">
                                        {
                                            isShowBtnUpdateStatus &&
                                            <Button className="mr-2" type="primary" icon="check" onClick={ this.onBulkUpdatePromotionCode }>{ isActive ? t('item.promotions.bulkDeactivated') : t('item.promotions.bulkActive') }</Button>
                                        }
                                        <Button type="primary" icon="search" onClick={ this.onSearchPromotion }>{ t('action.search') }</Button>
                                    </div>

                                </div>
                                <PromotionList loading={ isFetching }
                                               permissions={ permissionActions }
                                               promotions={ promotions }
                                               pagination={ pagination }
                                               onChange={ this.onTableChange }
                                               openUpdateStatus={ this.showModal }
                                               showHistory={ this.showHistory }
                                               showSchedules={ this.showSchedules }
                                               setShowHideActiveDeactivatedPromotion={ this.setShowHideActiveDeactivatedPromotion }
                                               ref={this.childPromotion}
                                />
                                { !!dataCode &&
                                <PromotionUpdateStatus
                                    data={ dataCode }
                                    handleOk={ this.handleOk }
                                    handleCancel={ this.handleCancel }
                                    note={ note }
                                    onChangeNote={ (value) => this.setState({ note: value }) }
                                />
                                }
                                { !!dataHistory &&
                                <PromotionHistory
                                    data={ { ...dataHistory, ...histories } }
                                    handleOk={ this.handleOk }
                                    handleCancel={ this.handleCancel }
                                    isFetchingHistory={ isFetchingHistory }
                                    onChange={ this.onTableChangeHistory }
                                />
                                }
                                { !!dataSchedules &&
                                <PromotionSchedules
                                    data={ dataSchedules }
                                    handleOk={ this.handleOk }
                                    handleCancel={ this.handleCancel }
                                />
                                }
                                {
                                    showChangeStatusGroup && 
                                    <UpdateStatusGroup
                                        show={this.state.showChangeStatusGroup}
                                        handleOk={ this.handleOkStatusExcel }
                                        handleCancel={ this.handleCancelStatusExcel }
                                    />
                                }
                            </TabPane>
                        }
                    </Tabs>
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    popupChangeStatusGroup = () => {
        this.props.clearStatusGroup()
        this.setState({
            showChangeStatusGroup: true
        })
    }

    handleOkStatusExcel = () => {
        this.setState({
            showChangeStatusGroup: false
        })
        this.props.getListPromotions(this.state.filters)
    }

    handleCancelStatusExcel = () => {
        this.setState({
            showChangeStatusGroup: false
        })
    }

    showSchedules = (record) => {
        this.setState({
            dataSchedules: {
                infoCode: record,
                list: record.schedules
            }
        })
    }

    selectFilterSearch = (input, option) => {
        const resultText = option.props.children.props.children;
        return this.getResultSearch(resultText, input)
    }

    onEnterSearch = (e) => {
        if (e.key === 'Enter') {
            this.onSearchPromotion()
        }
    }

    onSearchPromotion = () => {
        const newPagingObject = {
            pageSize: this.state.filters.pageSize,
            pageIndex: PAGINATION.pageIndex,
        }
        this.setState({
            filters: {...newPagingObject}
        })
        this.props.getListPromotions({...newPagingObject, ...this.state.dataSearch});
    }

    onChange = (fieldName, value) => {
        const dataSearch = { ...this.state.dataSearch };
        dataSearch[fieldName] = value;
        if (fieldName === 'campaignId') {
            dataSearch.bundleId = ''
        }
        this.setState({ dataSearch });
    };

    showHistory = (item) => {
        this.props.getHistoryCode({
            promotionCode: item.promotionCode
        })
        this.setState({
            dataHistory: {
                infoCode: item
            }
        })
    }

    showModal = (item) => {
        this.setState({ dataCode: item });
    }

    handleOk = () => {
        const { changeStatusCode, t } = this.props;
        const { dataCode, note } = this.state;
        if (!note.trim()) {
            message.error(t('validation.validateNotePromotion'))
            return
        }
        if (dataCode) {
            changeStatusCode(dataCode.promotionId, dataCode.bundleName, note, dataCode.isActive, this.state.filters);
        }
        this.resetValue();
    }

    handleCancel = (typePopup = '') => {
        if (typePopup === 'history') {
            this.props.resetHistoryCode()
        }
        this.resetValue();
    }

    resetValue = () => {
        this.setState({
            ...this.state,
            dataCode: null,
            note: '',
            dataHistory: null,
            dataSchedules: null
        })
    }

    onChangeLanguage = () => {
        this.props.getListPromotions(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPromotions({ ...newFilters, ...this.state.dataSearch });
    }

    onTableChangeHistory = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filtersHistory: newFilters
        });
        this.props.getHistoryCode({ ...newFilters, promotionCode: this.state.dataHistory.infoCode.promotionCode });
    }

    onClickDownloadExcel = () => {
        const { filters, dataSearch } = this.state
        this.props.exportExcel({ ...filters, ...dataSearch });
    }

    onViewPromotionCode = (data) => {
        if (data && data.campaignId && data.keyActive) {
            const campaignId = data.campaignId;
            const bundleId = data.bundleId ? data.bundleId : undefined;
            const dataSearch = {
                campaignId: campaignId,
                bundleId: bundleId,
            }
            this.setState({
                dataSearch: dataSearch,
            })
            this.setState({ activeTab: data.keyActive, fetchBundleLst: false });
            this.props.getBundlesByCampaignId(campaignId)
            this.props.getListPromotions({ ...dataSearch });
        }
    }

    onChangeTab = (keyActive) => {
        this.setState({ activeTab: keyActive, isShowBtnUpdateStatus: false });
        this.childPromotion && this.childPromotion.current && this.childPromotion.current.resetSelectedRowKeys();
        if (keyActive === 'PROMOTION') {
            this.setState({
                fetchBundleLst: false,
                dataSearch: {
                    textSearch: '',
                    campaignId: '',
                    bundleId: ''
                },
            });
            this.props.getListPromotions(this.state.filters);
        } else if (keyActive === 'BUNDLE') {
            this.setState({ fetchBundleLst: true });
        }
    }

    setShowHideActiveDeactivatedPromotion = (isShow, isActive, selectedRows) => {
        this.setState({
            isShowBtnUpdateStatus: isShow,
            isActive: isActive,
            selectedRows: selectedRows,
        })
    }
}

